export type FirmwareType = {
  hardwareType: string;
  firmwareType: string;
  description: string;
  id: string;
  tags: string[];
  version: string;
  createdAt: string;
  contentsBase64?: string | null;
  allowed_customers?: string[];
};

// The ARRAY ORDER IS THE ENUM: the API sends firmware_type as an integer and the
// UI reads it back as fwTypeOptions[firmware_type]. Append only — reordering
// silently relabels every existing artifact.
//
// "Lua script" is not firmware. It shares the type because the device takes it
// over the same upload commands (Ruptela Protocol 1.134 §7.4), which is what lets
// one screen manage both. See doc/tco4/dev-4965-lua-script-upload.md in
// flotilla_api.
export const fwTypeOptions = [
  { value: "normal", label: "Normal" },
  { value: "extender", label: "Extender" },
  { value: "combined", label: "Combined" },
  { value: "lua", label: "Lua script" },
];

export const fwTypeMap = {
  normal: 0,
  extender: 1,
  combined: 2,
  lua: 3,
};

// fwTypeOptionFor resolves an artifact's integer type to its option, falling back
// to the first entry for a value this build does not know. The call sites used to
// index the array directly, so a type added on the API side ahead of the UI took
// the whole list down with a TypeError on undefined.value rather than showing one
// oddly-labelled row.
export const fwTypeOptionFor = (firmwareType?: number) =>
  fwTypeOptions[firmwareType ?? 0] ?? fwTypeOptions[0];
